// @generated by TypeGen from LogbookApi/AlertApi - DO NOT EDIT

import type { IAlertCommandRequest, IAlertMessageRequest, IAlertReceiptRequest } from "../LogbookApp/AlertApi"
import type { IAppResponse } from "../LogbookApp/Routes"
import { IShipUserLevel } from "../LogbookModel/ShipUser"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface AlertApiEndpoints {
  "POST /api/ship/alert/manOverboard": {
    params: {};
    query: {};
    request: never;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/alert/message": {
    params: {};
    query: {};
    request: IAlertMessageRequest;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/alert/receipt/:alertName": {
    params: { alertName: string };
    query: {};
    request: IAlertReceiptRequest;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "PUT /api/ship/alert/:alertName": {
    params: { alertName: string };
    query: {};
    request: IAlertCommandRequest;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
}

export const alertApiEndpoints = {
  "POST /api/ship/alert/manOverboard": { targets: ["app"], permission: { ship: IShipUserLevel.viewCurrent } },
  "POST /api/ship/alert/message": { targets: ["app"], permission: { ship: IShipUserLevel.viewCurrent } },
  "POST /api/ship/alert/receipt/:alertName": { targets: ["app"], permission: { ship: IShipUserLevel.viewCurrent } },
  "PUT /api/ship/alert/:alertName": { targets: ["app"], permission: { ship: IShipUserLevel.viewCurrent } },
} as const;

export class AlertApi {
  constructor(private client: ApiClient) {}

  alert = {
    manOverboard: (a: ApiArgs<AlertApiEndpoints, "POST /api/ship/alert/manOverboard">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "POST /api/ship/alert/manOverboard", alertApiEndpoints["POST /api/ship/alert/manOverboard"].targets);
        return this.client.call<IAppResponse>("POST /api/ship/alert/manOverboard", a);
      },
      url: (): string => this.client.url("POST /api/ship/alert/manOverboard", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.viewCurrent,
    }),
    message: (a: ApiArgs<AlertApiEndpoints, "POST /api/ship/alert/message">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "POST /api/ship/alert/message", alertApiEndpoints["POST /api/ship/alert/message"].targets);
        return this.client.call<IAppResponse>("POST /api/ship/alert/message", a);
      },
      url: (): string => this.client.url("POST /api/ship/alert/message", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.viewCurrent,
    }),
    receipt: (a: ApiArgs<AlertApiEndpoints, "POST /api/ship/alert/receipt/:alertName">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "POST /api/ship/alert/receipt/:alertName", alertApiEndpoints["POST /api/ship/alert/receipt/:alertName"].targets);
        return this.client.call<IAppResponse>("POST /api/ship/alert/receipt/:alertName", a);
      },
      url: (): string => this.client.url("POST /api/ship/alert/receipt/:alertName", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.viewCurrent,
    }),
    update: (a: ApiArgs<AlertApiEndpoints, "PUT /api/ship/alert/:alertName">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "PUT /api/ship/alert/:alertName", alertApiEndpoints["PUT /api/ship/alert/:alertName"].targets);
        return this.client.call<IAppResponse>("PUT /api/ship/alert/:alertName", a);
      },
      url: (): string => this.client.url("PUT /api/ship/alert/:alertName", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.viewCurrent,
    }),
  };
}
